'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatTextdirectionLToR = function MdFormatTextdirectionLToR(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 30l-6.6 6.6v-5h-20v-3.2h20v-5z m-20-13.4q-2.7 0-4.7-1.9t-1.9-4.7 1.9-4.7 4.7-1.9h13.4v3.2h-3.4v18.4h-3.4v-18.4h-3.2v18.4h-3.4v-8.4z' })
        )
    );
};

exports.default = MdFormatTextdirectionLToR;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-textdirection-l-to-r.js
// module id = 2922
// module chunks = 0